import { View } from 'react-big-calendar';

import { calendarSettings } from '../config/calendarConfig';

/**
 * Mobile exposes [day, month], desktop [week, month]. Never pass a `view` that is
 * missing from current `views` — Calendar renders before `useEffect` runs and crashes
 * (e.g. reading `.title` on an undefined view component).
 */
export const resolveViewForLayout = (
  mobile: boolean,
  currentView: View
): View => {
  const allowed = mobile
    ? calendarSettings.mobileViews
    : calendarSettings.desktopViews;
  if ((allowed as readonly View[]).includes(currentView)) {
    return currentView;
  }
  return mobile
    ? calendarSettings.defaultMobileView
    : calendarSettings.defaultDesktopView;
};
